module.exports = __webpack_public_path__ + "ui-static/img/favicon.253751f7.svg";